'use client';
import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const faqs = [
  {
    key: 'faq-1',
    q: 'Apa perbedaan SAFARUNA dengan travel Umrah biasa?',
    a: 'SAFARUNA bukan travel Umrah paket standar. Kami adalah private Umrah concierge — setiap perjalanan dirancang khusus sesuai kebutuhan Anda, bukan template yang dipaksakan. Anda memilih hotel, tanggal, preferensi, dan budget sendiri.',
  },
  {
    key: 'faq-2',
    q: 'Berapa minimum pax untuk menggunakan SAFARUNA?',
    a: 'SAFARUNA melayani mulai dari 1 pax (solo) hingga grup keluarga besar. Tidak ada minimum pax. Bahkan, kami memiliki program khusus untuk pasangan dan jamaah lansia yang berangkat berdua.',
  },
  {
    key: 'faq-3',
    q: 'Bagaimana proses pemesanan di SAFARUNA?',
    a: 'Proses dimulai dari Journey Builder — Anda rancang perjalanan sendiri. Tim Concierge kami akan menghubungi Anda via WhatsApp untuk finalisasi detail. Setelah setuju, kami kirimkan quotation resmi. Booking dikonfirmasi setelah pembayaran DP.',
  },
  {
    key: 'faq-4',
    q: 'Apakah SAFARUNA terdaftar resmi?',
    a: 'Ya. SAFARUNA beroperasi melalui mitra PPIU (Penyelenggara Perjalanan Ibadah Umrah) berlisensi dari Kementerian Agama RI dan terdaftar di Nusuk Muassasah Saudi Arabia.',
  },
  {
    key: 'faq-5',
    q: 'Apa saja yang termasuk dalam paket SAFARUNA?',
    a: 'Setiap journey berbeda, namun umumnya mencakup: visa Umrah, tiket pesawat PP, hotel Makkah dan Madinah, transportasi selama di Saudi, muttawif/guide, dan pendampingan concierge. Anda bisa menambah atau mengurangi komponen sesuai kebutuhan.',
  },
  {
    key: 'faq-6',
    q: 'Bagaimana dengan pembayaran? Apakah bisa cicil?',
    a: 'Kami menerima DP 30% untuk konfirmasi booking, dengan cicilan hingga H-30 keberangkatan. Tersedia berbagai metode pembayaran: transfer bank, QRIS, dan kartu kredit.',
  },
];

export default function FAQSection() {
  const [open, setOpen] = useState<string | null>('faq-1');

  return (
    <section id="faq" className="py-20 lg:py-28 bg-ivory-gradient">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          <div>
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary/10 text-primary text-xs font-semibold uppercase tracking-widest mb-4">
              FAQ
            </span>
            <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4 leading-tight">
              Pertanyaan yang Sering Ditanyakan
            </h2>
            <p className="text-muted-foreground leading-relaxed mb-8">
              Tidak menemukan jawaban yang Anda cari? Tim Concierge kami siap membantu.
            </p>
            <a
              href="https://wa.me/6281234567890"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
            >
              Tanya via WhatsApp
            </a>
          </div>

          <div className="space-y-3">
            {faqs?.map((faq) => (
              <div key={faq?.key} className="card-base overflow-hidden">
                <button
                  onClick={() => setOpen(open === faq?.key ? null : faq?.key)}
                  className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left hover:bg-muted/30 transition-colors duration-150"
                  aria-expanded={open === faq?.key}
                >
                  <span className="font-semibold text-foreground text-sm leading-relaxed">{faq?.q}</span>
                  <ChevronDown
                    size={18}
                    className={`flex-shrink-0 text-muted-foreground transition-transform duration-200 ${open === faq?.key ? 'rotate-180' : ''}`}
                  />
                </button>
                {open === faq?.key && (
                  <div className="px-6 pb-5 animate-fade-in">
                    <p className="text-muted-foreground text-sm leading-relaxed">{faq?.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}